// Copyright (c) Docugami, Inc. All rights reserved.

import styled, { css } from "styled-components";
import { greyText, homeGray } from "components/shell/presentation/AppStyles";
import { userFontFamily, dgFontFamily } from "components/common/Fonts";
import { CatalogItemStatusProps, ICatalogItem } from "./Catalog";

const PreviewItemText = styled.span`
    font-family: ${userFontFamily};
    font-size: 36px;
    line-height: 40px;
`;

const PreviewHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: 1px solid ${greyText};
    padding: 10px;
    box-sizing: border-box;
`;

const PreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const PreviewContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    overflow: auto;
`;

const PreviewFontCss = css`
    font-family: ${userFontFamily};
    font-size: 18px;
    line-height: 24px;
    white-space: pre-wrap;
    color: ${homeGray};
`;

/* Styling for catalog preview section centered text */
export const PreviewText = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 70%;
    gap: 20px;

    ${PreviewFontCss}
`;

export const CatalogItemPreview = (props: { item: ICatalogItem }): JSX.Element => {
    return (
        <PreviewContainer>
            <PreviewHeader>
                <PreviewItemText>{props.item.name}</PreviewItemText>
                {!!props.item.statusProps && <CatalogItemPreviewStatus {...props.item.statusProps} />}
            </PreviewHeader>
            <PreviewContentContainer>
                {props.item.description}
            </PreviewContentContainer>
        </PreviewContainer>
    )
}

const PreviewHeaderStatus = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin: 0px 5px;
    width: fit-content;
    align-items: center;

    font-family: ${dgFontFamily};
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    text-transform: uppercase;
    color: ${homeGray};
`;

const IconContainer = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;
`;

const CatalogItemPreviewStatus = (props: CatalogItemStatusProps): JSX.Element => {
    const { label, icon } = props;
    return (
        <PreviewHeaderStatus key={label}>
            <IconContainer>{icon}</IconContainer>
            <span>{label}</span>
        </PreviewHeaderStatus>
    )
}

export const CatalogPlaceholderPreview = (props: { placeholderText?: string }): JSX.Element => {
    return (
        <PreviewContentContainer>
            <PreviewText>{props.placeholderText}</PreviewText>
        </PreviewContentContainer>
    )
}